const isEmpty=(v)=>{
  return v === null ||
  v === undefined ||
  v == "undefined" ||
  v == "null" ||
  ('' + v) === 'NaN' ||
  JSON.stringify(v) === '[]' ||
  JSON.stringify(v) === '{}' ||
  v === ''
}
export{
  isEmpty
}


// WEBPACK FOOTER //
// ./src/plugins/base.js